import { CompareTableColumn } from "in_queue/components/compare/comparisons";
import { ScenarioAllocatedUpgrade } from "in_queue/types/scenarioResultType";
import {
    currencyFormatter,
    dfaxFormatter
} from "../tables/agGrid/agGridHelpers";

export const upgradesCompareColumns: ReadonlyArray<
    CompareTableColumn<ScenarioAllocatedUpgrade>
> = [
    {
        kind: "join",
        colId: "projectId",
        headerName: "Project",
        getValue: (r) => r.projectId,
        width: 150
    },
    {
        kind: "join",
        colId: "networkUpgradeName",
        headerName: "Network upgrade",
        getValue: (r) => r.networkUpgradeName,
        flex: 1,
        tooltip: true
    },
    {
        kind: "compare",
        colId: "allocatedCost",
        headerName: "Allocated cost",
        getValue: (r) => r.allocatedCost,
        valueFormatter: currencyFormatter,
        sort: "desc"
    },
    {
        kind: "compare",
        colId: "totalCost",
        headerName: "Total cost",
        getValue: (r) => r.totalCost,
        valueFormatter: currencyFormatter
    },
    {
        kind: "compare",
        colId: "percentAllocation",
        headerName: "% Allocation",
        getValue: (r) => r.percentAllocation,
        valueFormatter: dfaxFormatter
    },
    {
        kind: "display",
        colId: "monitoredFacilityNames",
        headerName: "Monitored facilities",
        getValue: (rep) => rep.monitoredFacilityNames,
        tooltip: true
    }
];
